// SMD-658 full search results page: binds the shared result-row actions
// (SMD-439 side panel, two-way messaging) to the server-rendered sections.
//
// @see SearchController#index / app/views/search/index.html.haml

import SearchResultActions from '../../shared/search_result_actions';
import ShowingsViewPopup from '../dashboard/showings/view_popup';

// Point each section's pagination links at that section (#search-section-<key>)
// so a page change reloads back onto the section header instead of the top of
// the page — the "which section am I paging" cue the flat layout otherwise loses.
function wirePaginationAnchors(page) {
  page.querySelectorAll('.universal-search-page__pagination').forEach((pager) => {
    const section = pager.closest('.universal-search-page__section');
    if (!section || !section.id) {
      return;
    }
    pager.querySelectorAll('a[href]').forEach((link) => {
      link.hash = section.id;
    });
  });
}

// Re-align on the target section after load: the native hash jump can land
// slightly off once async content (e.g. lucide icon swaps) shifts layout.
function scrollToActiveSection(page) {
  const id = window.location.hash.slice(1);
  if (!id) {
    return;
  }
  const target = page.querySelector(`#${CSS.escape(id)}`);
  if (target) {
    window.requestAnimationFrame(() => target.scrollIntoView());
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const page = document.querySelector('.js-universal-search-page');
  if (!page) {
    return;
  }

  const showingsViewPopup = new ShowingsViewPopup();
  showingsViewPopup.init();
  document.addEventListener('sm-modal:opened', () => {
    showingsViewPopup.init('.js-sm-modal');
  });

  new SearchResultActions({}).bind(page);

  wirePaginationAnchors(page);
  scrollToActiveSection(page);
});
